import bootstrapApp from 'rawr/bootstrapApp';
import routes from './routes';

import 'rawr/layout/base.scss';

function bootstrap() {
	return bootstrapApp(routes);
}

window.bootstrap = bootstrap;

export default bootstrap;



/** WEBPACK FOOTER **
 ** collegeboard/client/rawr/apps/cbportal/index.jsx
 **/